import { Controller } from 'front-end-core/core/Router'
import getUrl from 'front-end-core/core/url'

import Main from './Main'
import Header from './Header'
import { DOCUMENTS_REVIEW } from 'constants/controllers'

export default new Controller({
  name: DOCUMENTS_REVIEW,
  route: ':aol/docreview/:category/:sectionId/:precedentIds',
  controller (
    Router,
    {
      scrollMain,
      url,
      query,
      params: { aol, category = null, sectionId = null, precedentIds = null }
    },
    render
  ) {
    const pageId = getUrl(DOCUMENTS_REVIEW, {
      aol,
      category,
      sectionId,
      precedentIds
    })
    render(
      { Main, Header },
      {
        aol,
        category,
        sectionId,
        precedentIds: precedentIds.split(',')
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol
      }
    )

    return pageId
  }
})
